const footerLinks = [
  {
    category: 'Vimeo',
    links: [
      {
        href: 'https://vimeo.com/about',
        gtm: 'footer_link_about_click',
        fa: 'container:footer|component:vimeo|keyword:about_vimeo',
        text: 'About Vimeo',
      },
      {
        href: 'https://vimeo.com/blog',
        gtm: 'footer_link_vimeo_blog_click',
        fa: 'container:footer|component:vimeo|keyword:vimeo_blog',
        text: 'Vimeo Blog',
      },
      {
        href: 'https://medium.com/vimeo-engineering-blog',
        gtm: 'footer_link_engineering_blog_click',
        fa: 'container:footer|component:vimeo|keyword:engineering_blog',
        text: 'Engineering Blog',
      },
      {
        href: 'https://vimeo.com/help/guidelines',
        gtm: 'footer_link_vimeo_guidelines_click',
        fa: 'container:footer|component:vimeo|keyword:vimeo_guidelines',
        text: 'Vimeo Guidelines',
      },
      {
        href: 'https://vimeo.com/vip',
        gtm: 'footer_link_partners_click',
        fa: 'container:footer|component:vimeo|keyword:partners',
        text: 'Partners',
      },
      {
        href: 'https://vimeo.com/jobs',
        gtm: 'footer_link_jobs_click',
        fa: 'container:footer|component:vimeo|keyword:jobs',
        text: 'Jobs',
      },
    ],
  },
  {
    category: 'API',
    links: [
      {
        href: '/api/guides/start',
        gtm: 'footer_link_getting_started_click',
        fa: 'container:footer|component:api|keyword:getting_started',
        text: 'Getting Started',
      },
      {
        href: '/api/authentication',
        gtm: 'footer_link_authentication_click',
        fa: 'container:footer|component:api|keyword:authentication',
        text: 'Authentication',
      },
      {
        href: '/api/upload/videos',
        gtm: 'footer_link_upload_videos_click',
        fa: 'container:footer|component:api|keyword:upload_videos',
        text: 'Working with Video Uploads',
      },
      {
        href: '/api/reference',
        gtm: 'footer_link_api_reference_click',
        fa: 'container:footer|component:api|keyword:api_reference',
        text: 'API Reference',
      },
      {
        href: '/api/libraries',
        gtm: 'footer_link_libraries_sdks_click',
        fa: 'container:footer|component:api|keyword:libraries_sdks',
        text: 'Libraries & SDKs',
      },
      {
        href: '/guidelines/rate-limiting',
        gtm: 'footer_link_rate_limits_click',
        fa: 'container:footer|component:api|keyword:rate_limits',
        text: 'Rate Limiting',
      },
      {
        href: '/api/changelog',
        gtm: 'footer_link_changelog_click',
        fa: 'container:footer|component:api|keyword:changelog',
        text: 'Changelog',
      },
      {
        href: '/guidelines/terms',
        gtm: 'footer_link_api_terms_of_service_click',
        fa: 'container:footer|component:api|keyword:api_terms_of_service',
        text: 'Developer Addendum',
      },
    ],
  },
  {
    category: 'HTML5 Player',
    links: [
      {
        href: '/api/oembed',
        gtm: 'footer_link_oembed_click',
        fa: 'container:footer|component:api|keyword:oembed',
        text: 'oEmbed',
      },
      {
        href: '/player',
        gtm: 'footer_link_player_sdk_click',
        fa: 'container:footer|component:api|keyword:player_sdk',
        text: 'Player SDK',
      },
    ],
  },
  {
    category: 'Help',
    links: [
      {
        href: '/help',
        gtm: 'footer_link_api_help_click',
        fa: 'container:footer|component:help|keyword:api_help',
        text: 'API Help',
      },
      {
        href: 'https://vimeo.com/help/contact',
        gtm: 'footer_link_contact_us_click',
        fa: 'container:footer|component:help|keyword:contact_us',
        text: 'Contact Us',
      },
      {
        href: 'https://stackoverflow.com/tags/vimeo',
        gtm: 'footer_link_stack_overflow_click',
        fa: 'container:footer|component:help|keyword:stack_overflow',
        text: 'Stack Overflow',
      },
      {
        href: 'https://vimeo.com/forums/api',
        gtm: 'footer_link_forums_click',
        fa: 'container:footer|component:help|keyword:forums',
        text: 'Forums',
      },
      {
        href: 'https://vimeo.com/help/sso?redirect_to=https://help.vimeo.com/hc/en-us/categories/202603398-Developers',
        gtm: 'footer_link_faq_click',
        fa: 'container:footer|component:help|keyword:faq',
        text: 'FAQ',
      },
    ],
  },
  {
    category: 'Upgrade',
    links: [
      {
        href: 'https://vimeo.com/upgrade?v=footer',
        gtm: 'footer_link_vimeo_starter_click',
        fa: 'container:footer|component:upgrade|keyword:starter',
        text: 'Vimeo Starter',
      },
      {
        href: 'https://vimeo.com/upgrade?v=footer',
        gtm: 'footer_link_vimeo_standard_click',
        fa: 'container:footer|component:upgrade|keyword:standard',
        text: 'Vimeo Standard',
      },
      {
        href: 'https://vimeo.com/upgrade?v=footer',
        gtm: 'footer_link_vimeo_advanced_click',
        fa: 'container:footer|component:upgrade|keyword:advanced',
        text: 'Vimeo Advanced',
      },
      {
        href: 'https://vimeo.com/live',
        gtm: 'footer_link_vimeo_live_click',
        fa: 'container:footer|component:upgrade|keyword:live',
        text: 'Vimeo Live',
      },
      {
        href: 'https://ott.vimeo.com',
        gtm: 'footer_link_vimeo_ott_click',
        fa: 'container:footer|component:upgrade|keyword:ott',
        text: 'Vimeo OTT',
      },
      {
        href: 'https://vimeo.extole.com/website_footer',
        gtm: 'footer_link_refer_friend_click',
        fa: 'container:footer|component:upgrade|keyword:refer_a_friend',
        text: 'Refer a friend',
      },
    ],
  },
];

export default footerLinks;
